import 'reflect-metadata';
import CareApp from './CareApp';
import ConsentApp from './ConsentsApp';
import { MobileProvider } from 'utilities/MobileContext';
import { ToastProvider } from 'react-components/app/ReusableToast';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { routes } from './routing/Routes';
import { Suspense } from 'react';
import RouteLoadingFallback from './routing/RouteLoadingFallback';
import AppRouterTemplate from './routing/AppRouterTemplate';
import { getAppRoutesFromConfigs } from './routing/GetAppRoutesFromConfigs';
import { tvDashboardRouteConfig } from './routing/routes/TvDashboardRoutes';

const AppWrapper = () => {
  const host = window.location.host;
  const parts = host.split('.');
  const subdomain = parts[0];

  return subdomain === 'consent' ? <ConsentApp /> : <CareApp />;
};

/**
 * `/tv-dashboard` must be declared **before** top-level `/:termKey`; otherwise `/tv-dashboard` matches the consent
 * flow (wrong layout). Consent stays a root-level route so it keeps its own Redux store — do not nest it under
 * {@link CareApp}.
 */
const router = createBrowserRouter([
  {
    path: '/',
    element: <AppWrapper />,
    children: routes[0].children,
  },
  {
    path: '/tv-dashboard',
    element: <AppWrapper />,
    children: [
      {
        element: <AppRouterTemplate />,
        children: getAppRoutesFromConfigs([tvDashboardRouteConfig]),
      },
    ],
  },
  {
    path: '/:termKey',
    element: <ConsentApp />,
  },
]);

const App = () => {
  return (
    <MobileProvider>
      <ToastProvider>
        <Suspense fallback={<RouteLoadingFallback />}>
          <RouterProvider router={router} />
        </Suspense>
      </ToastProvider>
    </MobileProvider>
  );
};

export default App;
